import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import colors from 'styles/constants/colors';

export const MainContainer = styled.section<{ backgroundColor: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  ${({ backgroundColor }) =>
    backgroundColor === colors.surfaceWhite
      ? `img {
    background-color: #f0f0f0;
  }`
      : ''};
`;

export const InnerContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${MEDIA_QUERIES.mdUp} {
    max-width: 1440px;
    padding: 4.5rem;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 130%;
  flex-direction: column;
  padding: ${SPACER.xlarge} ${SPACER.medium} 0;

  ${MEDIA_QUERIES.mdUp} {
    font-size: 2rem;
    flex-direction: row;
    max-width: 720px;
    padding: 0;
  }
`;

export const HeaderCell = styled.span`
  ${MEDIA_QUERIES.mdUp} {
    margin-right: ${SPACER.xsmall};
  }
`;
